import type { StatusPillVariant } from '@/shared/components/ui';

/**
 * Metadados de status de formulário (padrão-lista). O visual do pill vem do
 * StatusPill shared (F62) — aqui fica só o mapeamento semântico label/rank/variant.
 * Compartilhado por FormCard + FormListItem.
 */
export interface FormStatusMeta {
  label: string;
  /** rank para ordenação client-side (ativo → rascunho → inativo) */
  rank: number;
  /** variant semântico do StatusPill shared */
  variant: StatusPillVariant;
}

export const getFormStatusMeta = (status: string): FormStatusMeta => {
  switch (status) {
    case 'active':
      return { label: 'Ativo', rank: 0, variant: 'success' };
    case 'draft':
      return { label: 'Rascunho', rank: 1, variant: 'neutral' };
    case 'inactive':
      return { label: 'Inativo', rank: 2, variant: 'neutral' };
    default:
      return { label: 'Rascunho', rank: 1, variant: 'neutral' };
  }
};
